import {
  getAllStates,
  getAllDistricts,
  getAllPhcs,
  getAllPrograms,
  getAllSchemes,
  getAllSubcenters,
  getAllTalukas,
  getAllAreaTypes,
  getAllTrainings,
  getAllFaculties,
  getAllAreaCategories,
  getAllRoles,
  getAllVillages,
  getAllLgbs,
  getAccessLevels,
  getAllCorporations,
} from "../../../Services/MiniApisService";
export const FETCH_STATE_DATA = "FETCH_STATE_DATA";
export const FETCH_STATE_DATA_SUCCESS = "FETCH_STATE_DATA_SUCCESS";
export const FETCH_STATE_DATA_FAILURE = "FETCH_STATE_DATA_FAILURE";

export const FETCH_DISTRICT_DATA = "FETCH_DISTRICT_DATA";
export const FETCH_DISTRICT_DATA_SUCCESS = "FETCH_DISTRICT_DATA_SUCCESS";
export const FETCH_DISTRICT_DATA_FAILURE = "FETCH_DISTRICT_DATA_FAILURE";

export const FETCH_TALUKA_DATA = "FETCH_TALUKA_DATA";
export const FETCH_TALUKA_DATA_SUCCESS = "FETCH_TALUKA_DATA_SUCCESS";
export const FETCH_TALUKA_DATA_FAILURE = "FETCH_TALUKA_DATA_FAILURE";

export const FETCH_PHC_DATA = "FETCH_PHC_DATA";
export const FETCH_PHC_DATA_SUCCESS = "FETCH_PHC_DATA_SUCCESS";
export const FETCH_PHC_DATA_FAILURE = "FETCH_PHC_DATA_FAILURE";

export const FETCH_SUBCENTER_DATA = "FETCH_SUBCENTER_DATA";
export const FETCH_SUBCENTER_DATA_SUCCESS = "FETCH_SUBCENTER_DATA_SUCCESS";
export const FETCH_SUBCENTER_DATA_FAILURE = "FETCH_SUBCENTER_DATA_FAILURE";

export const FETCH_PROGRAM_DATA = "FETCH_PROGRAM_DATA";
export const FETCH_PROGRAM_DATA_SUCCESS = "FETCH_PROGRAM_DATA_SUCCESS";
export const FETCH_PROGRAM_DATA_FAILURE = "FETCH_PROGRAM_DATA_FAILURE";

export const FETCH_CORPORATION_DATA = "FETCH_CORPORATION_DATA";
export const FETCH_CORPORATION_DATA_SUCCESS = "FETCH_CORPORATION_DATA_SUCCESS";
export const FETCH_CORPORATION_DATA_FAILURE = "FETCH_CORPORATION_DATA_FAILURE";

export const FETCH_SCHEME_DATA = "FETCH_SCHEME_DATA";
export const FETCH_SCHEME_DATA_SUCCESS = "FETCH_SCHEME_DATA_SUCCESS";
export const FETCH_SCHEME_DATA_FAILURE = "FETCH_SCHEME_DATA_FAILURE";

export const FETCH_TRAINING_DATA = "FETCH_TRAINING_DATA";
export const FETCH_LGB_DATA = "FETCH_LGB_DATA";
export const FETCH_TRAINING_DATA_SUCCESS = "FETCH_TRAINING_DATA_SUCCESS";
export const FETCH_LGB_DATA_SUCCESS = "FETCH_LGB_DATA_SUCCESS";

export const FETCH_TRAINING_DATA_FAILURE = "FETCH_TRAINING_DATA_FAILURE";
export const FETCH_LGB_DATA_FAILURE = "FETCH_LGB_DATA_FAILURE";

export const FETCH_FACULTY_DATA = "FETCH_FACULTY_DATA";
export const FETCH_FACULTY_DATA_SUCCESS = "FETCH_FACULTY_DATA_SUCCESS";
export const FETCH_FACULTY_DATA_FAILURE = "FETCH_FACULTY_DATA_FAILURE";

export const FETCH_AREA_TYPE_DATA = "FETCH_AREA_TYPE_DATA";
export const FETCH_AREA_TYPE_DATA_SUCCESS = "FETCH_AREA_TYPE_DATA_SUCCESS";
export const FETCH_AREA_TYPE_DATA_FAILURE = "FETCH_AREA_TYPE_DATA_FAILURE";

export const FETCH_AREA_CATEGORY_DATA = "FETCH_AREA_CATEGORY_DATA";
export const FETCH_AREA_CATEGORY_DATA_SUCCESS =
  "FETCH_AREA_CATEGORY_DATA_SUCCESS";
export const FETCH_AREA_CATEGORY_DATA_FAILURE =
  "FETCH_AREA_CATEGORY_DATA_FAILURE";

export const FETCH_ROLE_DATA = "FETCH_ROLE_DATA";
export const FETCH_ROLE_DATA_SUCCESS = "FETCH_ROLE_DATA_SUCCESS";
export const FETCH_ROLE_DATA_FAILURE = "FETCH_ROLE_DATA_FAILURE";

export const FETCH_ACCESS_LEVEL_DATA = "FETCH_ACCESS_LEVEL_DATA";
export const FETCH_ACCESS_LEVEL_DATA_SUCCESS = "FETCH_ACCESS_LEVEL_DATA_SUCCESS";
export const FETCH_ACCESS_LEVEL_DATA_FAILURE = "FETCH_ACCESS_LEVEL_DATA_FAILURE";

export const FETCH_VILLAGE_DATA = "FETCH_VILLAGE_DATA";
export const FETCH_VILLAGE_DATA_SUCCESS = "FETCH_VILLAGE_DATA_SUCCESS";
export const FETCH_VILLAGE_DATA_FAILURE = "FETCH_VILLAGE_DATA_FAILURE";

export const RESET_DROPDOWN_OPTIONS = "RESET_DROPDOWN_OPTIONS";

export const resetDropdownOptions = () => {
  return (dispatch) => {
    dispatch({ type: RESET_DROPDOWN_OPTIONS });
  };
};

export const fetchStatesOptions = (languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_STATE_DATA });
    try {
      const optionData = await getAllStates(languageId);
      dispatch({
        type: FETCH_STATE_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_STATE_DATA_FAILURE });
    }
  };
};

export const fetchDistrictsOptions = (stateId, languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_DISTRICT_DATA });
    try {
      const optionData = await getAllDistricts(stateId, languageId);
      dispatch({
        type: FETCH_DISTRICT_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_DISTRICT_DATA_FAILURE });
    }
  };
};

export const fetchTalukasOptions = (districtId, languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_TALUKA_DATA });
    try {
      const optionData = await getAllTalukas(districtId, languageId);
      dispatch({
        type: FETCH_TALUKA_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_TALUKA_DATA_FAILURE });
    }
  };
};

export const fetchPhcsOptions = (talukaId, languageId, masterType, districtId, roleName, lgbId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_PHC_DATA });
    try {
      const optionData = await getAllPhcs(talukaId, languageId, masterType, districtId, roleName, lgbId);
      dispatch({
        type: FETCH_PHC_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_PHC_DATA_FAILURE });
    }
  };
};

export const fetchSubcentersOptions = (phcId, languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_SUBCENTER_DATA });
    try {
      const optionData = await getAllSubcenters(phcId, languageId);
      dispatch({
        type: FETCH_SUBCENTER_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_SUBCENTER_DATA_FAILURE });
    }
  };
};

export const fetchProgramsOptions = (languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_PROGRAM_DATA });
    try {
      const optionData = await getAllPrograms(languageId);
      dispatch({
        type: FETCH_PROGRAM_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_PROGRAM_DATA_FAILURE });
    }
  };
};

export const fetchSchemesOptions = (programId, languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_SCHEME_DATA });
    try {
      const optionData = await getAllSchemes(programId, languageId);
      dispatch({
        type: FETCH_SCHEME_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_SCHEME_DATA_FAILURE });
    }
  };
};

export const fetchTrainingOptions = (languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_TRAINING_DATA });
    try {
      const optionData = await getAllTrainings(languageId);
      dispatch({
        type: FETCH_TRAINING_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_TRAINING_DATA_FAILURE });
    }
  };
};

export const fetchLgbOptions = (languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_LGB_DATA });
    try {
      const optionData = await getAllLgbs(languageId);
      dispatch({
        type: FETCH_LGB_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_LGB_DATA_FAILURE });
    }
  };
};

export const fetchCorporationOptions = (languageId, districtId, lgbId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CORPORATION_DATA});
    try {
      const optionData = await getAllCorporations(languageId, districtId, lgbId);
      dispatch({
        type: FETCH_CORPORATION_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_CORPORATION_DATA_FAILURE });
    }
  };
};

export const fetchFacultyOptions = (languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_FACULTY_DATA });
    try {
      const optionData = await getAllFaculties(languageId);
      dispatch({
        type: FETCH_FACULTY_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_FACULTY_DATA_FAILURE });
    }
  };
};

export const fetchAreaTypesOptions = (languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_AREA_TYPE_DATA });
    try {
      const optionData = await getAllAreaTypes(languageId);
      dispatch({
        type: FETCH_AREA_TYPE_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_AREA_TYPE_DATA_FAILURE });
    }
  };
};

export const fetchAreaCategoriesOptions = (languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_AREA_CATEGORY_DATA });
    try {
      const optionData = await getAllAreaCategories(languageId);
      dispatch({
        type: FETCH_AREA_CATEGORY_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_AREA_CATEGORY_DATA_FAILURE });
    }
  };
};

export const fetchRolesOptions = (languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ROLE_DATA });
    try {
      const optionData = await getAllRoles(languageId);
      dispatch({
        type: FETCH_ROLE_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_ROLE_DATA_FAILURE });
    }
  };
};

export const fetchVillagesOptions = (subcenterId, languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_VILLAGE_DATA });
    try {
      const optionData = await getAllVillages(subcenterId, languageId);
      dispatch({
        type: FETCH_VILLAGE_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_VILLAGE_DATA_FAILURE });
    }
  };
};

export const fetchAccessLevelsOptions = (languageId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ACCESS_LEVEL_DATA });
    try {
      const optionData = await getAccessLevels(languageId);      
      dispatch({
        type: FETCH_ACCESS_LEVEL_DATA_SUCCESS,
        payload: optionData || [],
      });
    } catch (_error) {
      dispatch({ type: FETCH_ACCESS_LEVEL_DATA_FAILURE });
    }
  };
};

